import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/classnames/index.js';

var Layout = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (jsx("div", __assign({ className: classNames("ui equal width grid ck", className) }, props, { children: children }), void 0));
};

export { Layout as default };
